/**
 * Curated district autocomplete per enabled city (ADR-A16). District is free
 * text on listings and users; this list only feeds the autocomplete.
 * Keyed by cities.slug. HCMC uses the colloquial pre-2025 district names
 * because that is how people still arrange a meetup (OQ-A21).
 */
export const DISTRICTS: Record<string, readonly string[]> = {
  "ho-chi-minh": [
    "Quận 1",
    "Quận 3",
    "Quận 4",
    "Quận 5",
    "Quận 6",
    "Quận 7",
    "Quận 8",
    "Quận 10",
    "Quận 11",
    "Quận 12",
    "Bình Thạnh",
    "Phú Nhuận",
    "Tân Bình",
    "Tân Phú",
    "Gò Vấp",
    "Bình Tân",
    "Thủ Đức",
    "Nhà Bè",
    "Hóc Môn",
    "Bình Chánh",
    "Củ Chi",
    "Cần Giờ",
    "Thuận An",
    "Dĩ An",
    "Thủ Dầu Một",
    "Biên Hoà",
    "Vũng Tàu",
  ],
};
